import { get } from 'lodash';
import validation from '../../../scripts/services/validation';
import { trackPayButtonClick, trackOtherPaymentMethodClick, trackPayAsLegalClick } from './PayByCardModal.tracking';
import { getTitle, getSubmitText, getSum } from './utils';
import { getYandexWidgetToken } from '../../../../../shared/api/getYandexWidgetToken';
import { plural } from '@cian/utils';
import { isBillingUnstable, getProblemReason } from '../../../../../shared/selectors/billingStatus';
import { selectAnalyticsOfferStatus } from '../../../../../shared/selectors/analytics';
import './pay-by-card.css';

export default [
  '$rootScope', '$scope', 'options', 'placingTermsApi', 'apiService', 'popupService', '$uibModalInstance',
  'userService', 'cardPaymentService', 'homeownerService', 'httpApi', 'logger', 'config', 'deviceService', 'store',
  function (
    $rootScope, $scope, options, placingTermsApi, apiService, popupService, $uibModalInstance, userService,
    cardPaymentService, homeownerService, httpApi, logger, config, deviceService, store
  )
{
  const maxPaymentAmount = config.getStrict('yandexKassaMaxPaymentAmount');
  const state = store.getState();
  const { source, amount } = options;
  const analyticsOfferStatus = selectAnalyticsOfferStatus(state);

  cardPaymentService.resetState();

  $scope.isMobile = deviceService.isMobile;
  $scope.title = getTitle(source);
  $scope.submitText = getSubmitText(source);
  this.sum = getSum({
    source,
    amount,
    totalAmount: placingTermsApi.getTotalPriceAmount(),
    balance: userService.user.balance,
  });

  $scope.isAccountTypeUndefined = get($rootScope, 'user.billingInfo.accountType') === undefined;
  $scope.maxPaymentAmount = maxPaymentAmount;

  $scope.isBillingUnstable = isBillingUnstable(state);
  $scope.billingProblemReason = getProblemReason(state, 'deposit');

  const sumValidationMessages = {
    parse: 'Введите сумму платежа',
    min: 'Минимальная сумма платежа – 1 рубль',
    max: `Максимальная сумма платежа – ${maxPaymentAmount} ${plural(maxPaymentAmount, ['рубль', 'рубля', 'рублей'])}`,
    required: 'Не указана сумма платежа',
  };

  $scope.$watch('form', () => {
    $scope.validation = validation(this.form, 'sum', sumValidationMessages);
  });

  $scope.isVisibleOtherPayMethods = () => {
    return homeownerService.userType !== 'homeowner';
  };

  $scope.trackOtherPaymentMethodClick = trackOtherPaymentMethodClick(source, analyticsOfferStatus);
  $scope.trackPayAsLegalClick = trackPayAsLegalClick(source, analyticsOfferStatus);

  $scope.handleSubmit = () => {
    if (!this.form.$valid) {
      return;
    }

    const isYandexKassaV2Enabled = config.getStrict('isYandexKassaV2.Enabled');

    trackPayButtonClick({ source, recommendedSum: this.sum, offerStatus: analyticsOfferStatus });

    cardPaymentService.setPaymentSum(this.sum);

    $scope.isPending = true;

    const request = isYandexKassaV2Enabled
      ? getYandexWidgetToken({ httpApi, logger }, { amount: this.sum })
      : apiService.getYandexFrameSettings(this.sum);

    request.then((settings) => {
      $scope.isPending = false;

      if (deviceService.isMobile) {
        $uibModalInstance.closed.then(() => {
          popupService.openPopup('yandexPay', { settings });
        });
      } else {
        popupService.openPopup('yandexPay', { settings });
      }

      $uibModalInstance.close('payByCard');
    });
  };
}];
